<template>
  <v-flex class="px-3 question">
    <p class="required-block_left mt-3 mb-2">
      {{ $t('sheet.fields_required') }}
    </p>
    <div class="question">
      <ul :class="['questions-list', { deprecated: readOnly }]">
        <SummaryTitle />
        <EndingReason :read-only="readOnly" />
        <EndingReasonExplanation :read-only="readOnly" />
        <SummaryDescription :read-only="readOnly" />
        <InfoAlert
          v-for="(item, key) in warningMessage.text"
          :key="key"
          :text="item"
          :warn="false"
          class="mt-4"
        />
        <FurtherStoryButtons
          :read-only="readOnly"
          type="summary"
          @finish="goToFamilyPage"
        />
      </ul>
    </div>
  </v-flex>
</template>

<script>
import FurtherStoryButtons from '@/components/FurtherStory/FurtherStoryButtons';
import SummaryTitle from '@/components/FurtherStory/Summary/SummaryTitle';
import SummaryDescription from '@/components/FurtherStory/Summary/SummaryDescription';
import EndingReason from '@/components/FurtherStory/Summary/EndingReason';
import EndingReasonExplanation from '@/components/FurtherStory/Summary/EndingReasonExplanation';
import InfoAlert from '@/components/widgets/InfoAlert';
export default {
    name: 'SummaryQuestions',
    components: {
        InfoAlert,
        EndingReasonExplanation,
        EndingReason,
        SummaryDescription,
        SummaryTitle,
        FurtherStoryButtons
    },
    inject: ['$validator'],
    props: {
        readOnly: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        warningMessage () {
            return this.$store.getters['furtherStory/getQuestions'].warning;
        }
    },
    methods: {
        goToFamilyPage () {
            this.$router.push({ name: 'family-card', params: { id: this.$route.params.familyId } });
        }
    }
};
</script>

<style scoped></style>
